import { render, staticRenderFns } from "./sustainability-module-v2.vue?vue&type=template&id=06503d32"
import script from "./sustainability-module-v2.vue?vue&type=script&lang=js"
export * from "./sustainability-module-v2.vue?vue&type=script&lang=js"
import style0 from "./sustainability-module-v2.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports